import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Assessment from "@/pages/Assessment";
import Book from "@/pages/Book";
import Consultation from "@/pages/Consultation";
import Privacy from "@/pages/Privacy";
import Report from "@/pages/Report";
import Admin from "@/pages/Admin";
import RecoverPayment from "@/pages/RecoverPayment";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/assessment" element={<Assessment />} />
          <Route path="/book" element={<Book />} />
          <Route path="/consultation" element={<Consultation />} />
          {/* ORYVEN page hidden for now (reactivate later): restore import + route to <Oryven /> */}
          <Route path="/oryven" element={<Navigate to="/" replace />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/report/:id" element={<Report />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/recover-payment" element={<RecoverPayment />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
